export const LOGIN_KEY = 'jd#@DJ12&jfi$Cd'
